import {useTranslation} from 'react-i18next';
import {getHourMinutesDate, tsToDate} from '../../../library/dates';
import * as css from './style.css';
import sanitizeHtml from '../../../library/sanitizeHtml';

interface EventDetailsProps {
    nameFirst: string;
    nameLast: string;
    eventTitle?: string;
    location?: string;
    timeStart?: string;
    timeEnd?: string;
    emailContent?: string;
}

function EventDetails({ 
    nameFirst, 
    nameLast, 
    eventTitle, 
    location, 
    timeStart, 
    timeEnd, 
    emailContent 
}: EventDetailsProps) {
    const {t} = useTranslation('suspendedConfirmation');

    return (
        <div>
            <css.elementWithMargin as={css.title}>
                {t('hello')}, {nameFirst} {nameLast}
            </css.elementWithMargin>
            <css.elementWithMargin as={css.boldText}>{t('eventRegistered')}:</css.elementWithMargin>
            <css.iconsContainer>
                {eventTitle && <div>
                    <css.bigIcon $iconType="Name" />
                    <div>{eventTitle}</div>
                </div>}
                {location && <div>
                    <css.bigIcon $iconType="Location" />
                    <div>{location}</div>
                </div>}
                {timeStart && <div>
                    <css.bigIcon $iconType="Time" />
                    <div>{tsToDate(Number(timeStart))}
                        <br />
                        {getHourMinutesDate(Number(timeStart))} - {getHourMinutesDate(Number(timeEnd))}
                    </div>
                </div>}
            </css.iconsContainer>
            {emailContent && (
                <css.elementWithMargin dangerouslySetInnerHTML={sanitizeHtml(emailContent)} />
            )}
        </div>
    );
}

export default EventDetails; 